
import Vue, { PropType } from 'vue';
import Icon from '../icon/Icon.vue';

export type MenuItem = {
    id: string;
    label: string;
};

export default Vue.extend({
    name: 'DropdownMenu',

    components: {
        Icon
    },

    props: {
        options: {
            type: Array as PropType<MenuItem[]>,
            default: () => ([])
        },

        selected: {
            type: Object as PropType<MenuItem>,
            default: () => ({})
        }
    },

    data() {
        return {
            expanded: false
        };
    },

    methods: {
        onOptionSelected(option: MenuItem): void {
            this.$emit('select', option.id);
            this.expanded = false;
        }
    }
});
